import { FC } from "react";
import { Helmet } from "react-helmet";
import { routes } from "~/constants";
import { canonical } from "~/utils/canonical";

const text = {
  description:
    "Here are frequently-asked questions about Conceive—from enrollment to success rates, and how our fertility support program helps members get pregnant faster.",
  pageTitle: "FAQs",
};

export const Meta: FC = () => {
  return (
    <Helmet>
      <title itemProp="name" lang="en">
        {text.pageTitle}
      </title>
      <meta name="description" content={text.description} />
      {canonical(routes.faqs)}
    </Helmet>
  );
};
